/**
 * Created by anatoly on 03.04.2025
 */

const RepairHintView = function () {
    this.hintFinger = undefined;

    cleverapps.availableMove.on("hide", this.hide.bind(this), this);
    cleverapps.availableMove.on("repair", this.show.bind(this), this);
};

RepairHintView.prototype.show = function (move) {
    this.hide();

    this.hintFinger = FingerView.hintTap(move.target, {
        delay: move.delay / 1000,
        repeatDelay: move.interval / 1000
    });
};

RepairHintView.prototype.hide = function () {
    FingerView.remove(this.hintFinger);
    this.hintFinger = undefined;
};